/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

import { Item, Page } from 'componentregistry';
import { Platform } from 'componentregistry/platform/Platform';
import { autoPopulateChildren } from 'designer/state';
import { camelCase } from 'lodash-es';
import Store from 'store/Store';
import { GeneratePage } from './ds_registry';

function getPage(ds: string): Page {
  const alias = ds ? camelCase(`${ds}Alias`) : '';
  const page: {
    set: Item<'ActionSet'>;
    card: Item<'Card'>;
    form: Item<'Form'>;
    menu: Item<'Menu'>;
    root: Item<'Page'>;
    avatar: Item<'Avatar'>;
    goBack: Item<'ActionGoBack'>;
    flexItem: Item<'FlexItem'>;
    menuItem: Item<'MenuItem'>;
    flexPanel: Item<'FlexPanel'>;
    menuItem1: Item<'MenuItem'>;
    backButton: Item<'Button'>;
    cardHeader: Item<'CardHeader'>;
    iconButton: Item<'IconButton'>;
    saveButton: Item<'Button'>;
    cardActions: Item<'CardActions'>;
    cardContent: Item<'CardContent'>;
    createRecord: Item<'ActionCreate'>;
    saveDataStore: Item<'ActionSave'>;
    plusIconButton: Item<'IconButton'>;
    resetDataStore: Item<'ActionReset'>;
    triggerOnClick: Item<'TriggerOnClick'>;
    menuItemDivider: Item<'MenuItemDivider'>;
    triggerOnClick1: Item<'TriggerOnClick'>;
    triggerOnClick2: Item<'TriggerOnClick'>;
    triggerOnClick3: Item<'TriggerOnClick'>;
    triggerOnClick4: Item<'TriggerOnClick'>;
    triggerOnClick5: Item<'TriggerOnClick'>;
    resetChangesMenuItem: Item<'MenuItem'>;
    dataStore: Item<'DataStore'>;
    dataStoreReference: Item<'DataStoreReference'>;
    saveDataStore1: Item<'ActionSave'>;
    set1: Item<'ActionSet'>;
    createRecord1: Item<'ActionCreate'>;
  } = {
    avatar: {
      children: [],
      itemId: 'avatar',
      parent: 'cardHeader',
      props: {
        text: {
          type: 'expression',
          value: `$.${alias}.firstName`,
        },
      },
      type: 'Avatar',
    },
    backButton: {
      children: ['triggerOnClick5'],
      itemId: 'backButton',
      parent: 'cardActions',
      props: {
        startIcon: {
          iconName: '',
        },
        text: {
          type: 'text',
          value: 'Back',
        },
        variant: 'text',
      },
      type: 'Button',
    },
    card: {
      children: ['cardHeader', 'cardContent', 'cardActions'],
      itemId: 'card',
      parent: 'dataStoreReference',
      props: {},
      type: 'Card',
    },
    cardActions: {
      children: ['backButton', 'saveButton'],
      itemId: 'cardActions',
      parent: 'card',
      props: {},
      type: 'CardActions',
    },
    cardContent: {
      children: ['flexPanel'],
      itemId: 'cardContent',
      parent: 'card',
      props: {},
      type: 'CardContent',
    },
    cardHeader: {
      children: ['avatar', 'plusIconButton', 'iconButton'],
      itemId: 'cardHeader',
      parent: 'card',
      props: {
        title: {
          type: 'expression',
          value: `$.${alias}.$isFromDB ? \`Update \${$.${alias}.firstName}\` : 'Add New'`,
        },
      },
      type: 'CardHeader',
    },
    createRecord: {
      children: ['set'],
      itemId: 'createRecord',
      parent: 'triggerOnClick1',
      props: {
        alias,
      },
      type: 'ActionCreate',
    },
    createRecord1: {
      children: ['set1'],
      itemId: 'createRecord1',
      parent: 'triggerOnClick3',
      props: {
        alias,
      },
      type: 'ActionCreate',
    },
    flexItem: {
      children: ['form'],
      itemId: 'flexItem',
      parent: 'flexPanel',
      props: {},
      type: 'FlexItem',
    },
    flexPanel: {
      children: ['flexItem'],
      itemId: 'flexPanel',
      parent: 'cardContent',
      props: {},
      type: 'FlexPanel',
    },
    form: {
      children: [],
      itemId: 'form',
      parent: 'flexItem',
      props: {},
      type: 'Form',
    },
    goBack: {
      children: [],
      itemId: 'goBack',
      parent: 'triggerOnClick5',
      props: {},
      type: 'ActionGoBack',
    },
    iconButton: {
      children: ['menu'],
      itemId: 'iconButton',
      parent: 'cardHeader',
      props: {
        toolTip: {
          type: 'text',
          value: 'More actions',
        },
      },
      type: 'IconButton',
    },
    menu: {
      children: [
        'menuItem',
        'resetChangesMenuItem',
        'menuItemDivider',
        'menuItem1',
      ],
      itemId: 'menu',
      parent: 'iconButton',
      props: {},
      type: 'Menu',
    },
    menuItem: {
      children: ['triggerOnClick3'],
      itemId: 'menuItem',
      parent: 'menu',
      props: {
        icon: {
          iconName: 'plus',
          iconType: 'light',
        },
        label: {
          type: 'text',
          value: 'Add New',
        },
      },
      type: 'MenuItem',
    },
    menuItem1: {
      children: ['triggerOnClick4'],
      itemId: 'menuItem1',
      parent: 'menu',
      props: {
        icon: {
          iconName: 'save',
          iconType: 'light',
        },
        label: {
          type: 'text',
          value: 'Save',
        },
      },
      type: 'MenuItem',
    },
    menuItemDivider: {
      children: [],
      itemId: 'menuItemDivider',
      parent: 'menu',
      props: {},
      type: 'MenuItemDivider',
    },
    plusIconButton: {
      children: ['triggerOnClick1'],
      itemId: 'plusIconButton',
      parent: 'cardHeader',
      props: {
        icon: {
          iconName: 'plus',
          iconType: 'light',
        },
        toolTip: {
          type: 'text',
          value: 'Add new row',
        },
      },
      type: 'IconButton',
    },
    resetChangesMenuItem: {
      children: ['triggerOnClick2'],
      itemId: 'resetChangesMenuItem',
      parent: 'menu',
      props: {
        icon: {
          iconName: 'undo',
          iconType: 'light',
        },
        label: {
          type: 'text',
          value: 'Reset Changes',
        },
      },
      type: 'MenuItem',
    },
    resetDataStore: {
      children: [],
      itemId: 'resetDataStore',
      parent: 'triggerOnClick2',
      props: {
        alias,
      },
      type: 'ActionReset',
    },
    root: {
      children: ['dataStore', 'dataStoreReference'],
      itemId: 'root',
      parent: 'root',
      props: {
        windowTitle: {
          type: 'text',
          value: 'Blank Page',
        },
      },
      type: 'Page',
    },
    dataStoreReference: {
      children: ['card'],
      itemId: 'dataStoreReference',
      parent: 'root',
      props: {
        alias,
      },
      type: 'DataStoreReference',
    },
    dataStore: {
      children: [],
      itemId: 'dataStore',
      parent: 'root',
      props: {
        alias,
        autoQuery: true,
        dataSource: ds,
        maxRows: 1,
      },
      type: 'DataStore',
    },
    saveButton: {
      children: ['triggerOnClick'],
      itemId: 'saveButton',
      parent: 'cardActions',
      props: {
        disableCondition: `!$.${alias}.$dirty`,
        startIcon: {
          iconName: 'save',
          iconType: 'light',
        },
        text: {
          type: 'text',
          value: 'Save',
        },
      },
      type: 'Button',
    },
    saveDataStore: {
      children: [],
      itemId: 'saveDataStore',
      parent: 'triggerOnClick',
      props: { alias },
      type: 'ActionSave',
    },
    saveDataStore1: {
      children: [],
      itemId: 'saveDataStore1',
      parent: 'triggerOnClick4',
      props: { alias },
      type: 'ActionSave',
    },
    set: {
      children: [],
      itemId: 'set',
      parent: 'createRecord',
      props: {
        attribute: 'dateTime',
        value: {
          type: 'expression',
          value: 'sysdate()',
        },
      },
      type: 'ActionSet',
    },
    set1: {
      children: [],
      itemId: 'set1',
      parent: 'createRecord1',
      props: {
        attribute: 'dateTime',
        value: {
          type: 'expression',
          value: 'sysdate()',
        },
      },
      type: 'ActionSet',
    },
    triggerOnClick: {
      children: ['saveDataStore'],
      itemId: 'triggerOnClick',
      parent: 'saveButton',
      props: {},
      type: 'TriggerOnClick',
    },
    triggerOnClick1: {
      children: ['createRecord'],
      itemId: 'triggerOnClick1',
      parent: 'plusIconButton',
      props: {},
      type: 'TriggerOnClick',
    },
    triggerOnClick2: {
      children: ['resetDataStore'],
      itemId: 'triggerOnClick2',
      parent: 'resetChangesMenuItem',
      props: {},
      type: 'TriggerOnClick',
    },
    triggerOnClick3: {
      children: ['createRecord1'],
      itemId: 'triggerOnClick3',
      parent: 'menuItem',
      props: {},
      type: 'TriggerOnClick',
    },
    triggerOnClick4: {
      children: ['saveDataStore1'],
      itemId: 'triggerOnClick4',
      parent: 'menuItem1',
      props: {},
      type: 'TriggerOnClick',
    },
    triggerOnClick5: {
      children: ['goBack'],
      itemId: 'triggerOnClick5',
      parent: 'backButton',
      props: {},
      type: 'TriggerOnClick',
    },
  };
  return page;
}

const Form: GeneratePage = async ({
  platform,
  store,
  appUid,
  pageId,
}: {
  platform: Platform;
  store?: Store<unknown> | null;
  appUid: string;
  pageId: string;
}): Promise<Page> => {
  let page = getPage(store ? store.ds : '');
  if (store) {
    page = await autoPopulateChildren({
      platform,
      page,
      store,
      itemId: 'form',
      silent: true,
      appUid,
      pageId,
    });
  }
  return page;
};

export default Form;
